import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import APP_CONSTANTS from '../../config/constants';
import Axios from 'axios';
import $ from 'jquery'
import ReadAxios from '../axiosComponent/read';
const MySkuCode = ({
    field: { name, value },
    form: { touched, errors, setFieldValue },
    ...props
}) => {
    const errorText = touched[name] && errors[name];
    const [contents, setcontents] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        ReadAxios({ url: `skuMaster` })
            .then((result) => {
                setcontents(result.data.resultSet)
                setloading(false)
            })
    }, [])

    let options = []
    if (contents.length > 0) {
        contents.map((object, index) => {
            let temp = {}
            temp.key = object.skuMasterId
            temp.text = object.skuCode
            temp.value = object.skuCode
            temp.extra = object
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        let extraDetails = data.options.find((option)=>option.value===data.value).extra
        setFieldValue(name, data.value)
        if(props.nameValue && extraDetails.skuName) setFieldValue(props.nameValue, extraDetails.skuName)
        if( props.desc && extraDetails.skuDescription) setFieldValue(props.desc, extraDetails.skuDescription)
        
    }
    return (
        <Dropdown
            search
            selection
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            {...props}
        />

    )
}

export default MySkuCode